import React, { useState } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../shared/BrandModal.css";

export const SendBackToEmployeeModal = ({
  setToggle,
  toggleValue,
  onSubmit,
  requestId: requestId,
}) => {
  const [reason, setReason] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  const toggle = () => {
    setToggle(!toggle);
  };

  const submitted = async (e) => {
    e.preventDefault();

    let validated = validate();

    if (!validated) {
      return;
    }

    toggle();
    onSubmit(requestId, reason);
  };

  const validate = () => {
    let isSuccess = true;

    if (!reason) {
      setShowAdditionalError(true);
      isSuccess = false;
    }

    return isSuccess;
  };

  return (
    <Modal isOpen={toggleValue} toggle={toggle} size="lg" className="brand-modal">
      <ModalHeader toggle={toggle}>Resubmit Request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Please provide a reason that will be included in the notification email.
        </p>
        <Form onSubmit={submitted}>
          <FormGroup>
            <Label for="reason">Reason</Label>
            <Input
              type="textarea"
              name="reason"
              id="reason"
              placeholder="Reason text that will be included in email"
              onChange={(e) => setReason(e.target.value)}
              value={reason}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--success">
              <FontAwesomeIcon icon={faCheck} /> Confirm
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={() => toggle()}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
